import React from 'react';
import styles from './DynamicBatteryIcon.module.css';

/**
 * @param {Object} props
 * @param {number} props.percentage - the percentage in the icon
 * @param {string} [props.color='#fff'] - The main color of the icon
 * @param {number} [props.width=75] - The width of the battery
 * @param {number} [props.height=40] - the height of the icon
 */
const DynamicBatteryIcon = ({ percentage, color = '#fff', width = 75, height = 40 }) => (
  <div className={styles.iconWrapper}>
    <div className={styles.batteryWrapper} style={{ height }}>
      <div className={styles.battery} style={{ width }}>
        <div className={styles.batteryFiller} style={{ backgroundColor: color, width: `${percentage}%` }} />
      </div>
      <div className={styles.extraTip} />
    </div>
  </div>
);

export default DynamicBatteryIcon;
